import * as React from "react";
import * as moment from "moment";
import { createValidator } from "not-valid";

import { BaseInput, SharedProps } from "../base-input";

export interface DatetimeInputProps extends SharedProps<moment.Moment> {
    format?: string;
}

export class DatetimeInput extends React.Component<DatetimeInputProps> {

    constructor(props: DatetimeInputProps) {
        super(props);

        this.getFormat = this.getFormat.bind(this);
        this.getValueForInput = this.getValueForInput.bind(this);
        this.getValueFromInput = this.getValueFromInput.bind(this);
    }

    public render() {
        const DatetimeBaseInput = BaseInput as unknown as new () => BaseInput<moment.Moment>;

        const message = this.props.format
            ? `Please enter a valid datetime in the format ${this.props.format}`
            : "Please enter a valid datetime";

        const validator = createValidator<moment.Moment>((v: any) => v !== undefined && v !== null && v.isValid(), message);

        return (
            <DatetimeBaseInput
                defaultValue={undefined}
                getValueFromInput={this.getValueFromInput}
                getValueForInput={this.getValueForInput}
                type="datetime-local"
                requiredValidator={validator}
                {...this.props}
            />
        );
    }

    private getValueFromInput(value: string): moment.Moment {

        if (value === "") {
            return null;
        }

        const result = moment(value, this.getFormat(), true);

        if (result.isValid() === false) {
            return null;
        }

        return result;
    }

    private getValueForInput(value: moment.Moment): string {
        if (value == null) {
            return "";
        }

        return value.format(this.getFormat());
    }

    private getFormat() {
        return this.props.format || (moment as any).HTML5_FMT.DATETIME_LOCAL;
    }
}
